import {Plugin} from '@oracle/ortl-core';
import {ClipboardPipeline} from '@oracle/ortl-clipboard';
import {PasteFromOffice} from '@oracle/ortl-paste-from-office';
import {UpcastWriter} from '@oracle/ortl-engine';

const ALLOWED_STYLES = {
	color: true,
	background: true,
	'background-color': true,
	'font-size': true,
	'font-family': true,
	'font-weight': true,
	'font-style': true,
	'text-align': true,
	'text-decoration': true,
	margin: true,
	'margin-left': true,
	'margin-right': true,
};

export default class PasteFromOfficeCleanup extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'PasteFromOfficeCleanup';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ClipboardPipeline, PasteFromOffice];
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const clipboardPipeline = editor.plugins.get('ClipboardPipeline');
		clipboardPipeline.on(
			'inputTransformation',
			(evt, data) => {
				if (data._isTransformedWithPasteFromOffice) {
					const documentFragment = data.content;
					const writer = new UpcastWriter(documentFragment.document);
					const range = writer.createRangeIn(documentFragment);
					const elementsToRemove = [];
					const elementsToText = [];
					for (const value of range) {
						if (value.type === 'elementStart') {
							const element = value.item;
							if (element.name.includes(':')) {
								elementsToRemove.push(element);
							}
							const stylesToRemove = element
								.getStyleNames()
								.filter((styleName) => element.name === 'li' || !ALLOWED_STYLES[styleName]);
							if (stylesToRemove.length) {
								writer.removeStyle(stylesToRemove, element);
							}
							const classesToRemove = Array.from(element.getClassNames());
							if (classesToRemove.length) {
								writer.removeClass(classesToRemove, element);
							}
							writer.removeAttribute('lang', element);
							if (element.name === 'span' && !element.getStyleNames().length) {
								elementsToText.push(element);
							}
						}
					}
					elementsToRemove.forEach((element) => writer.remove(element));
					elementsToText.forEach((element) => {
						if (element.childCount === 1) {
							writer.replace(element, element.getChild(0));
						}
					});
				}
			},
			{priority: 'high'},
		);
	}
}
